<template>
  <on-demand-report-preview
    v-if="selectedCustomer.id"
    :tier="tierType"
    :id="selectedCustomer.id"
    :reportId="reportId"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import OnDemandReportPreview from "@/views/Common/Reports/OnDemand/Preview/index.vue";

import { TIER } from "@/constants";

export default {
  name: "OneOffReportWrapper",
  components: {
    OnDemandReportPreview,
  },
  data() {
    return {
      tierType: TIER.domainGroups,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
    reportId() {
      return this.$route.params.id || null;
    },
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t(`Report: ${this.$route.params.id}`));
    this.setPageSubtitle([]);
  },
};
</script>
